import React from "react";

function formatSessionDate(session) {
  const raw = session?.started_at || session?.created_at || session?.date;
  if (!raw) return "No date";

  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return "No date";

  return d.toLocaleString();
}

function getSeverityLabel(session) {
  if (session?.severity) return session.severity;

  const summary = `${session?.summary || ""}`.toLowerCase();

  if (
    summary.includes("severe") ||
    summary.includes("panic") ||
    summary.includes("vertigo") ||
    summary.includes("neurolog") ||
    summary.includes("brain") ||
    summary.includes("persistent")
  ) {
    return "moderate";
  }

  return "untriaged";
}

function getBadgeClass(value) {
  const v = `${value || ""}`.toLowerCase();

  if (v === "high" || v === "critical" || v === "flagged") {
    return "mgsession-pill danger";
  }

  if (v === "moderate") return "mgsession-pill warning";
  if (v === "low") return "mgsession-pill soft";
  if (v === "completed" || v === "reviewed") return "mgsession-pill soft";
  if (v === "draft" || v === "pending" || v === "untriaged") {
    return "mgsession-pill neutral";
  }

  return "mgsession-pill";
}

export default function SessionCard({ session, onOpen }) {
  const dateLabel = formatSessionDate(session);
  const severityLabel = getSeverityLabel(session);
  const statusLabel = session?.status || "draft";

  return (
    <button
      type="button"
      className="mgsession-card-button"
      onClick={() => onOpen?.(session)}
    >
      <article className="mgsession-card">
        <div className="mgsession-card-top">
          <div>
            <span className="mgsession-kicker">Clinical record</span>
            <h3>{session?.title || "Clinical Session"}</h3>
            <p>
              {dateLabel} • {session?.owner || "Unknown"}
            </p>
          </div>

          <div className="mgsession-badge-stack">
            <span className={getBadgeClass(statusLabel)}>{statusLabel}</span>
            <span className={getBadgeClass(severityLabel)}>{severityLabel}</span>
          </div>
        </div>

        <p className="mgsession-summary">
          {session?.summary || "No summary available yet."}
        </p>

        {session?.tags?.length ? (
          <div className="mgsession-tag-row">
            {session.tags.slice(0, 3).map((tag) => (
              <span key={tag} className="mgsession-pill">
                {tag}
              </span>
            ))}
          </div>
        ) : null}
      </article>
    </button>
  );
}